import React from 'react';
import { Text, TextName } from '../../../../sdk/text/Text';
import { OutlineGlassBackgroundCard } from '../../../../components/outline-glass-background-card/OutlineGlassBackgroundCard';
import styles from './style.module.scss';

interface TechBenefitsCardProps {
  title: React.ReactNode;
  body: string;
  iconSrc?: string;
}

export const TechBenefitsCard: React.FC<TechBenefitsCardProps> = ({
  title,
  body,
  iconSrc,
}) => {
  return (
    <OutlineGlassBackgroundCard className={styles.card}>
      {iconSrc && <img src={iconSrc} alt="" className={styles.arrow} />}
      <Text type={TextName.SuperBigText} className={styles.title}>{title}</Text>
      <Text type={TextName.Text}>{body}</Text>
    </OutlineGlassBackgroundCard>
  );
};
